/* eslint-disable */
import * as Types from '../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type ListDataSourcesQueryVariables = Types.Exact<{
    input: Types.DataSourceListInput;
}>;

export type ListDataSourcesQuery = { __typename?: 'Query' } & {
    listDataSources?: Types.Maybe<
        Array<
            Types.Maybe<
                { __typename?: 'DataSource' } & Pick<
                    Types.DataSource,
                    | 'id'
                    | 'name'
                    | 'dsConnectorType'
                    | 'connectorTypeId'
                    | 'dataType'
                    | 'state'
                    | 'applianceId'
                    | 'authType'
                    | 'orgUnitId'
                    | 'orgName'
                >
            >
        >
    >;
};

export type ListEdcSupportedConnectorsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ListEdcSupportedConnectorsQuery = { __typename?: 'Query' } & {
    listEDCSupportedConnectors: Array<
        { __typename?: 'EDCConnector' } & Pick<
            Types.EdcConnector,
            'connector_type' | 'edc_connector_type' | 'display_name' | 'supported_auth_types'
        > & {
                field_mapping?: Types.Maybe<
                    Array<
                        Types.Maybe<
                            { __typename?: 'FieldMapping' } & Pick<
                                Types.FieldMapping,
                                'connector_field' | 'field' | 'fieldPath' | 'type' | 'secret'
                            >
                        >
                    >
                >;
                additional_fields?: Types.Maybe<
                    Array<
                        Types.Maybe<
                            { __typename?: 'EDCAdditionalField' } & Pick<
                                Types.EdcAdditionalField,
                                'name' | 'label' | 'tooltip' | 'type' | 'fieldPath' | 'placeholder' | 'required'
                            >
                        >
                    >
                >;
                transformations?: Types.Maybe<
                    Array<
                        Types.Maybe<
                            { __typename?: 'EDCTransformation' } & Pick<
                                Types.EdcTransformation,
                                'type' | 'source_fields' | 'target_field' | 'separator' | 'index'
                            >
                        >
                    >
                >;
            }
    >;
};

export const ListDataSourcesDocument = gql`
    query listDataSources($input: DataSourceListInput!) {
        listDataSources(input: $input) {
            id
            name
            dsConnectorType
            connectorTypeId
            dataType
            state
            applianceId
            authType
            orgUnitId
            orgName
        }
    }
`;

/**
 * __useListDataSourcesQuery__
 *
 * To run a query within a React component, call `useListDataSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDataSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDataSourcesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListDataSourcesQuery(
    baseOptions: Apollo.QueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>,
) {
    return Apollo.useQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(ListDataSourcesDocument, baseOptions);
}
export function useListDataSourcesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ListDataSourcesQuery, ListDataSourcesQueryVariables>,
) {
    return Apollo.useLazyQuery<ListDataSourcesQuery, ListDataSourcesQueryVariables>(
        ListDataSourcesDocument,
        baseOptions,
    );
}
export type ListDataSourcesQueryHookResult = ReturnType<typeof useListDataSourcesQuery>;
export type ListDataSourcesLazyQueryHookResult = ReturnType<typeof useListDataSourcesLazyQuery>;
export type ListDataSourcesQueryResult = Apollo.QueryResult<ListDataSourcesQuery, ListDataSourcesQueryVariables>;
export const ListEdcSupportedConnectorsDocument = gql`
    query listEDCSupportedConnectors {
        listEDCSupportedConnectors {
            connector_type
            edc_connector_type
            display_name
            supported_auth_types
            field_mapping {
                connector_field
                field
                fieldPath
                type
                secret
            }
            additional_fields {
                name
                label
                tooltip
                type
                fieldPath
                placeholder
                required
            }
            transformations {
                type
                source_fields
                target_field
                separator
                index
            }
        }
    }
`;

/**
 * __useListEdcSupportedConnectorsQuery__
 *
 * To run a query within a React component, call `useListEdcSupportedConnectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEdcSupportedConnectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEdcSupportedConnectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListEdcSupportedConnectorsQuery(
    baseOptions?: Apollo.QueryHookOptions<ListEdcSupportedConnectorsQuery, ListEdcSupportedConnectorsQueryVariables>,
) {
    return Apollo.useQuery<ListEdcSupportedConnectorsQuery, ListEdcSupportedConnectorsQueryVariables>(
        ListEdcSupportedConnectorsDocument,
        baseOptions,
    );
}
export function useListEdcSupportedConnectorsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ListEdcSupportedConnectorsQuery,
        ListEdcSupportedConnectorsQueryVariables
    >,
) {
    return Apollo.useLazyQuery<ListEdcSupportedConnectorsQuery, ListEdcSupportedConnectorsQueryVariables>(
        ListEdcSupportedConnectorsDocument,
        baseOptions,
    );
}
export type ListEdcSupportedConnectorsQueryHookResult = ReturnType<typeof useListEdcSupportedConnectorsQuery>;
export type ListEdcSupportedConnectorsLazyQueryHookResult = ReturnType<typeof useListEdcSupportedConnectorsLazyQuery>;
export type ListEdcSupportedConnectorsQueryResult = Apollo.QueryResult<
    ListEdcSupportedConnectorsQuery,
    ListEdcSupportedConnectorsQueryVariables
>;
